import { createSlice } from '@reduxjs/toolkit';

const initialExceptiondateState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  locationForEdit: undefined,
  lastError: null,
  defaultRows: 10,
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const exceptiondateSlice = createSlice({
  name: 'exceptiondate',
  initialState: initialExceptiondateState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // exceptiondateFetched
    exceptiondateFetched: (state, action) => {
      state.actionsLoading = false;
      state.customerForEdit = action.payload.customerForEdit;
      state.error = null;
    },
    // exceptiondateFetched
    exceptiondatesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // exceptiondateCreated
    exceptiondateCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.exceptiondate);
    },
    // exceptiondateUpdated
    exceptiondateUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map((entity) => {
        if (
          entity.idExceptionDate ===
          action.payload.exceptiondate.idExceptionDate
        ) {
          return action.payload.exceptiondate;
        }
        return entity;
      });
    },
    // exceptiondateDeleted
    exceptiondateDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.idExceptionDate !== action.payload.id,
      );
    },
    // Default Rows
    itemsRowsNoUpdate: (state, action) => {
      state.defaultRows = action.payload.rows;
    },
  },
});
